// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import {CanvasAnchor} from './canvas-anchor.js'
import {EntityAnchor} from './entity-anchor.js'
import {ReplyAnchor} from './reply-anchor.js'
import {TextAnchor} from './text-anchor.js'

export enum Anchor {
  NONE = 0,
  CanvasAnchor = 1,
  TextAnchor = 2,
  EntityAnchor = 3,
  ReplyAnchor = 4
}

export function unionToAnchor(
  type: Anchor,
  accessor: (
    obj: CanvasAnchor | EntityAnchor | ReplyAnchor | TextAnchor
  ) => CanvasAnchor | EntityAnchor | ReplyAnchor | TextAnchor | null
): CanvasAnchor | EntityAnchor | ReplyAnchor | TextAnchor | null {
  switch (Anchor[type]) {
    case 'NONE':
      return null
    case 'CanvasAnchor':
      return accessor(new CanvasAnchor())! as CanvasAnchor
    case 'TextAnchor':
      return accessor(new TextAnchor())! as TextAnchor
    case 'EntityAnchor':
      return accessor(new EntityAnchor())! as EntityAnchor
    case 'ReplyAnchor':
      return accessor(new ReplyAnchor())! as ReplyAnchor
    default:
      return null
  }
}

export function unionListToAnchor(
  type: Anchor,
  accessor: (
    index: number,
    obj: CanvasAnchor | EntityAnchor | ReplyAnchor | TextAnchor
  ) => CanvasAnchor | EntityAnchor | ReplyAnchor | TextAnchor | null,
  index: number
): CanvasAnchor | EntityAnchor | ReplyAnchor | TextAnchor | null {
  switch (Anchor[type]) {
    case 'NONE':
      return null
    case 'CanvasAnchor':
      return accessor(index, new CanvasAnchor())! as CanvasAnchor
    case 'TextAnchor':
      return accessor(index, new TextAnchor())! as TextAnchor
    case 'EntityAnchor':
      return accessor(index, new EntityAnchor())! as EntityAnchor
    case 'ReplyAnchor':
      return accessor(index, new ReplyAnchor())! as ReplyAnchor
    default:
      return null
  }
}
